import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IEnumModel } from 'src/app/models/enum.model';
import { ILinhaDoTempoModel } from 'src/app/models/linha-tempo.model';
import { AvaliacaoService } from 'src/app/services/avaliacao.service';
import { BaseFormComponent } from '../base-form/base-form.component';
import { data } from 'jquery';
import { RelatoriaService } from 'src/app/services/relatoria.service';

@Component({
  selector: 'app-linha-do-tempo',
  templateUrl: './linha-do-tempo.component.html',
  styleUrls: ['./linha-do-tempo.component.scss']
})
export class LinhaDoTempoComponent extends BaseFormComponent implements OnInit {
  @Input() aba: number;
  @Input() public model: ILinhaDoTempoModel = {} as ILinhaDoTempoModel;
  @Input() tipoTrabalhoRef: number;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    public relatoriaService: RelatoriaService,
    private avaliacaoService: AvaliacaoService,
    public matDialog: MatDialog
  ) {
    super(route, toastr, router, localeService, matDialog);

    if (this.visualizar) {
      this.titulo = 'Visualizar Linha do Tempo';
    }
  }

  ngOnInit() {
    this.obterTipoDocumento();
    this.avaliacaoService.obter(this.model?.tipoDocumento?.codigo, this.id)
      .then(_ => {
        this.model = {} as ILinhaDoTempoModel;

        console.log(this.model)

        console.log(_.dados);
        this.model.datas = _?.dados?.datas;
        let tamanhoArray = this.model.datas?.length;
        if (tamanhoArray > 0) {
          this.model.datas[tamanhoArray-1].acoes.push({id: 0,
            acao: { codigo: 0, nome: 'Criado', descricao: 'Criado com sucesso.' } as IEnumModel
          });
        }
        else {
          this.model.datas = [
            {
              acoes: [{
                id: 0,
                acao: { codigo: 0, nome: 'Criado', descricao: 'Criado com sucesso.' } as IEnumModel
              }]
            }
          ]
        }

        this.model.tipoDocumento = _.dados?.tipoDocumento;
      });
  }

  public imprimir(id: number) {
    localStorage.setItem('timelineImprimir', this.router.url)
    let url= '';
    switch (this.model?.tipoDocumento.nome) {
        case 'PEA':
          url = `${window.location.origin}/imprimir-linha-do-tempo/${id}/tipo-trabalho/pea`;
          window.open(url, '_blank');
          break;
        case 'PAA':
          url = `${window.location.origin}/imprimir-linha-do-tempo/${id}/tipo-trabalho/paa`;
          window.open(url, '_blank');
          break;
        case 'PAACEspecial':
          url = `${window.location.origin}/imprimir-linha-do-tempo/${id}/tipo-trabalho/paa`;
          window.open(url, '_blank');
          break;
        case 'OPA':
          url = `${window.location.origin}/imprimir-linha-do-tempo/${id}/tipo-trabalho/opa`;
          window.open(url, '_blank');
        break;
        case 'Planejamento':
          url = `${window.location.origin}/imprimir-linha-do-tempo/${id}/tipo-trabalho/planejamento`;
          window.open(url, '_blank');
        break;
        case 'OSA':
          url = `${window.location.origin}/imprimir-linha-do-tempo/${id}/tipo-trabalho/osa`;
          window.open(url, '_blank');
        break;
        case 'ExecucaoAuditoria':
          url = `${window.location.origin}/imprimir-linha-do-tempo/${id}/tipo-trabalho/execucao`;
          window.open(url, '_blank');
        break;
     }
  }

  public imprimirRelatoria(id: number) {
    localStorage.setItem('timelineImprimir', this.router.url)
    let url = '';
    switch (this.model?.tipoDocumento.nome) {
      case 'PEA':
         url = `${window.location.origin}/visualizar-relatoria/${id}/tipo-trabalho/pea`;
        window.open(url, '_blank');
        break;
      case 'PAA':
         url = `${window.location.origin}/visualizar-relatoria/${id}/tipo-trabalho/paa`;
        window.open(url, '_blank');
        break;
      case 'PAACEspecial':
        url = `${window.location.origin}/visualizar-relatoria/${id}/tipo-trabalho/paa`;
        window.open(url, '_blank');
        break;
      case 'OPA':
        url = `${window.location.origin}/visualizar-relatoria/${id}/tipo-trabalho/opa`;
        window.open(url, '_blank');
        break;
      case 'Planejamento':
        url = `${window.location.origin}/visualizar-relatoria/${id}/tipo-trabalho/planejamento`;
        window.open(url, '_blank');
        break;
      case 'OSA':
        url = `${window.location.origin}/visualizar-relatoria/${id}/tipo-trabalho/osa`;
        window.open(url, '_blank');
        break;
      case 'ExecucaoAuditoria':
        url = `${window.location.origin}/visualizar-relatoria/${id}/tipo-trabalho/execucao`;
        window.open(url, '_blank');
        break;
    }
  }

  public obterTipoDocumento() {

    if(!this.tipoTrabalhoRef || this.tipoTrabalhoRef == 0){
      const path = this.route.routeConfig.path?.toString();

      if (path?.includes('pea')) {
        this.model.tipoDocumento = {
          codigo: 1,
          nome: 'PEAC',
          descricao: 'PEAC'
        } as IEnumModel;
      }
      else if (path?.includes('paa')) {
        this.model.tipoDocumento = {
          codigo: 2,
          nome: 'PAAC',
          descricao: 'PAAC'
        } as IEnumModel;
      }
      else if (path?.includes('opa')) {
        this.model.tipoDocumento = {
          codigo: 3,
          nome: 'OPA',
          descricao: 'OPA'
        } as IEnumModel;
      }
      else if (path?.includes('osa-execucao')) {
        this.model.tipoDocumento = {
          codigo: 15,
          nome: 'EXECUÇÃO',
          descricao: 'EXECUÇÃO'
        } as IEnumModel;
      }
      else if (path?.includes('osa')) {
        this.model.tipoDocumento = {
          codigo: 4,
          nome: 'OSA',
          descricao: 'OSA'
        } as IEnumModel;
      }
      else if (path?.includes('auditoria')) {
        this.model.tipoDocumento = {
          codigo: 6,
          nome: 'auditoria',
          descricao: 'auditoria'
        } as IEnumModel;
      }
      else if (path?.includes('planejamento')) {
        this.model.tipoDocumento = {
          codigo: 7,
          nome: 'Planejamento',
          descricao: 'Planejamento'
        } as IEnumModel;
      }
    }else{

      if(this.tipoTrabalhoRef == 2){
        this.model.tipoDocumento = {
          codigo: 2,
          nome: 'PAAC',
          descricao: 'PAAC'
        } as IEnumModel;
      }else if(this.tipoTrabalhoRef == 8){
        this.model.tipoDocumento = {
          codigo: 8,
          nome: 'PAAC - Especial',
          descricao: 'PAAC - Especial'
        } as IEnumModel;
      }

    }

  }

  public downloadRelatoria(anexoId: number): void {
  this.relatoriaService.downloadAnexo(anexoId).then((blob: Blob) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'relatoria';
    a.click();
    window.URL.revokeObjectURL(url);
  }).catch(err => {
    this.exibirMensagemErro(err?.mensagem?.descricao ?? 'Erro ao baixar arquivo.');
  });
}

  mostrarBotaoFechar(): boolean{
    const path = this.route.routeConfig.path?.toString();
    return path?.includes('paa');
  }

  public cancelar() {
    const path = this.route.routeConfig.path?.toString();

    if(path?.includes('paa')){
      this.router.navigate(['/paa']);
    }else if(path?.includes('pea')){
      this.router.navigate(['/pea']);
    }else if(path?.includes('opa')){
      this.router.navigate(['/opa']);
    }else if(path?.includes('osa-execucao')){
      this.router.navigate(['/osa-execucao']);
    }else if(path?.includes('osa')){
      this.router.navigate(['/osa']);
    }else if(path?.includes('auditoria')){
      this.router.navigate(['/auditoria']);
    }else if(path?.includes('planejamento')){
      this.router.navigate(['/planejamento']);
    }

  }
}
